<template>
  <RevCardCarousel
    v-if="hasArticles"
    :next-alternative-text="i18n(translations.nextSlideText)"
    :prev-alternative-text="i18n(translations.prevSlideText)"
  >
    <RevEditorialCard
      v-for="article in articles"
      :key="article.id"
      :alt="article.imageAlt"
      class="mb-16"
      :content="article.text"
      :cta="i18n(translations.readMore)"
      data-test="article-card"
      :image="article.imageSrc"
      :image-props="article.imageProps"
      :title="article.title"
      :title-kicker="article.category"
      title-tag="h3"
      :to="article.link"
    />
  </RevCardCarousel>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { Link } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCardCarousel } from '@ds/components/CardCarousel'
import { RevEditorialCard } from '@ds/components/EditorialCard'

import translations from './ArticleCardsCarousel.translations'

export type Article = {
  title: string
  category: string
  text: string
  id: string
  imageSrc: string
  imageAlt: string
  link: Link
  imageProps?: {
    width: number
    height: number
  }
}
const props = defineProps<{
  articles: Article[]
}>()

const i18n = useI18n()

const hasArticles = computed(() => props.articles.length > 0)
</script>
